<template>
  <Popover ref="placeholderPopover" :showHeader="true" headerTitle="Insert Placeholder" sizeClass="popover-xlarge">
    <div>
      <LoadingPanel :loading="loading" :loadingError="loadingError" />

      <div v-if="!loading && !loadingError">
        <div class="p-2">
          <FormInputText v-model="searchText" placeholder="Search Placeholders" />
        </div>

        <div class="placeholder-popover-list">
          <StaticDataTable class="static-table-list" striped hover>
            <template v-slot:header>
              <tr>
                <th>Description</th>
                <th>Code</th>
              </tr>
            </template>
            <template v-slot:body>
              <template v-for="placeholder in filteredPlaceholderList">
                <tr :key="`ph-${placeholder.code}`" @click.prevent="insertClicked(placeholder.code)" class="placeholder-row">
                  <td><strong>{{placeholder.name}}</strong></td>
                  <td>[{{placeholder.code}}]</td>
                </tr>
              </template>
            </template>
            <template v-slot:empty v-if="placeholderList.length == 0 || filteredPlaceholderList.length == 0">
              <span v-if="placeholderList.length == 0">No placeholders found</span>
              <span v-if="filteredPlaceholderList.length == 0 && placeholderList.length > 0">No placeholders found for search query</span>
            </template>
          </StaticDataTable>      
        </div>
      </div>
    </div>
  </Popover>
</template>

<style lang="scss" scoped>
.placeholder-popover-list {
  padding: 0.25rem;
  font-size: 13px;
  max-height: 30vh;
  overflow-y: scroll;
}
.placeholder-row {
  cursor:pointer;
}
</style>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'
import FormMixin from '@/mixins/form'

export default {
  name: 'AutomationInsertPlaceholderPopover',
  mixins: [FormMixin],
  components: {
    Popover,
  },
  data() {
    return {
      searchText: '',
      loading: false,
      loadingError: '',
      placeholderList: []
    }
  },
  computed: {
    filteredPlaceholderList() {
      var searchText = ('' + this.searchText).toLowerCase().trim()

      if(searchText.length == 0)
        return this.placeholderList

      // Simple client side search
      return this.placeholderList.filter(placeholder => {
        return (placeholder.code.toLowerCase().includes(searchText) || placeholder.name.toLowerCase().includes(searchText))
      })
    },
  },
  methods: {
    requestPlaceholderData(availableModelList, availablePlaceholderList) {
      this.loading = true
      this.loadingError = ''

      var placeholderData = {
        modelList: availableModelList,
        placeholderList: availablePlaceholderList
      }

      this.$apiService.automationService.calculatePlaceholderList(placeholderData)
      .then(response => {
        this.placeholderList = response.data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    },
    displayFromElement(element, availableModelList, availablePlaceholderList) {
      // Reset
      this.searchText = ''

      this.$refs.placeholderPopover.displayFromElement(element)

      this.requestPlaceholderData(availableModelList, availablePlaceholderList)
    },
    insertClicked(code) {
      this.$emit('insertClicked', code)
      this.$refs.placeholderPopover.hidePopover()
    }
  }
}
</script>